import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navigation.module.scss';

import { getTranslation } from '../../../../utils/translation';
import classnames from 'classnames';

export default function Navigation() {
    return (
        <nav>
            <ul className={`${styles.menu} white-space-nowrap`}>
                <li className={styles.menuItem}>
                    <NavLink to='/app/home' activeClassName={styles.active}>
                        {getTranslation('menu.home')}
                    </NavLink>
                </li>
                <li className={styles.menuItem}>
                    <NavLink to='/app/sports' activeClassName={styles.active}>
                        {getTranslation('menu.sports')}
                    </NavLink>
                </li>
                <li className={classnames(styles.menuItem, styles.live)}>
                    <NavLink to='/app/live' activeClassName={styles.active}>
                        {getTranslation('menu.live')}
                    </NavLink>
                </li>
                <li className={classnames(styles.menuItem, styles.hasSubMenu)}>
                    <NavLink
                        to='/app/e-sports'
                        isActive={(match, location) => location.pathname.includes('/app/e-')}
                        activeClassName={styles.active}
                    >
                        {getTranslation('menu.e-sports')}
                    </NavLink>
                    <ul className={styles.subMenu}>
                        <li className={styles.menuItem}>
                            <NavLink to='/app/e-sports' activeClassName={styles.active}>
                                {getTranslation('menu.prematch')}
                            </NavLink>
                        </li>
                        <li className={styles.menuItem}>
                            <NavLink to='/app/e-live' activeClassName={styles.active}>
                                {getTranslation('menu.live')}
                            </NavLink>
                        </li>
                    </ul>
                </li>
                <li className={styles.menuItem}>
                    <NavLink to='/app/point' activeClassName={styles.active}>
                        {getTranslation('menu.point')}
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
}
